import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const ThanksHero = lazy(() => import('components/Sections/Thanks'))
const Footer = lazy(() => import('components/Layout/Footer'))

function Thanks() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <ThanksHero />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default Thanks